var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('div', {
        staticClass: "page"
    }, [
        _vm._m(0),
        _c('van-form', {
            ref: "contactsRef",
            on: {
                "submit": _setup.onSubmit,
                "failed": _setup.onFailed
            }
        }, [
            _c('div', {
                staticClass: "form-box"
            }, [
                _c('div', {
                    staticClass: "form-title"
                }, [
                    _vm._v("Contacto 1")
                ]),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.textRelation1 ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Relación con usted")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "readonly": "",
                            "clickable": "",
                            "name": "linkConnection1",
                            "value": _setup.textRelation1,
                            "label": "",
                            "placeholder": "Relación con usted",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Relación con usted'
                                }
                            ],
                            "right-icon": _setup.showPickerRelation ? '' : 'arrow'
                        },
                        on: {
                            "click": function($event) {
                                return _setup.showPopup(1);
                            }
                        }
                    })
                ], 1),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.name1 ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Nombre completo")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "name": "titleCase1",
                            "clearable": "",
                            "placeholder": "Nombre completo",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Nombre completo'
                                }
                            ]
                        },
                        model: {
                            value: _setup.name1,
                            callback: function callback($$v) {
                                _setup.name1 = $$v;
                            },
                            expression: "name1"
                        }
                    })
                ], 1),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.phone1 ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Nombre completo")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "name": "mobileNumber1",
                            "maxlength": "10",
                            "type": "tel",
                            "clearable": "",
                            "placeholder": "Número de móvil (p. ej.: 1234567890)",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Número de móvil (p. ej.: 1234567890)'
                                },
                                {
                                    pattern: _setup.patternPhone,
                                    message: 'Número de móvil (p. ej.: 1234567890)'
                                }
                            ]
                        },
                        model: {
                            value: _setup.phone1,
                            callback: function callback($$v) {
                                _setup.phone1 = $$v;
                            },
                            expression: "phone1"
                        }
                    })
                ], 1)
            ]),
            _c('div', {
                staticClass: "form-box"
            }, [
                _c('div', {
                    staticClass: "form-title"
                }, [
                    _vm._v("Contacto 2")
                ]),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.textRelation2 ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Relación con usted")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "readonly": "",
                            "clickable": "",
                            "name": "linkConnection2",
                            "value": _setup.textRelation2,
                            "label": "",
                            "placeholder": "Relación con usted",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Relación con usted'
                                }
                            ],
                            "right-icon": _setup.showPickerRelation ? '' : 'arrow'
                        },
                        on: {
                            "click": function($event) {
                                return _setup.showPopup(2);
                            }
                        }
                    })
                ], 1),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.name2 ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Nombre completo")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "name": "titleCase2",
                            "clearable": "",
                            "placeholder": "Nombre completo",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Nombre completo'
                                }
                            ]
                        },
                        model: {
                            value: _setup.name2,
                            callback: function callback($$v) {
                                _setup.name2 = $$v;
                            },
                            expression: "name2"
                        }
                    })
                ], 1),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.phone2 ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Número de móvil (p. ej.: 1234567890)")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "name": "mobileNumber2",
                            "maxlength": "10",
                            "type": "tel",
                            "clearable": "",
                            "placeholder": "Número de móvil (p. ej.: 1234567890)",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Número de móvil (p. ej.: 1234567890)'
                                },
                                {
                                    pattern: _setup.patternPhone,
                                    message: 'Número de móvil (p. ej.: 1234567890)'
                                }
                            ]
                        },
                        model: {
                            value: _setup.phone2,
                            callback: function callback($$v) {
                                _setup.phone2 = $$v;
                            },
                            expression: "phone2"
                        }
                    })
                ], 1)
            ]),
            _c('div', {
                staticClass: "form-box"
            }, [
                _c('div', {
                    staticClass: "form-title"
                }, [
                    _vm._v("Contacto 3")
                ]),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.textRelation3 ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Relación con usted")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "readonly": "",
                            "clickable": "",
                            "name": "linkConnection3",
                            "value": _setup.textRelation3,
                            "label": "",
                            "placeholder": "Relación con usted",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Relación con usted'
                                }
                            ],
                            "right-icon": _setup.showPickerRelation ? '' : 'arrow'
                        },
                        on: {
                            "click": function($event) {
                                return _setup.showPopup(3);
                            }
                        }
                    })
                ], 1),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.name3 ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Nombre completo")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "name": "titleCase3",
                            "clearable": "",
                            "placeholder": "Nombre completo",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Nombre completo'
                                }
                            ]
                        },
                        model: {
                            value: _setup.name3,
                            callback: function callback($$v) {
                                _setup.name3 = $$v;
                            },
                            expression: "name3"
                        }
                    })
                ], 1),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.phone3 ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Número de móvil (p. ej.: 1234567890)")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "name": "mobileNumber3",
                            "maxlength": "10",
                            "type": "tel",
                            "clearable": "",
                            "placeholder": "Número de móvil (p. ej.: 1234567890)",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Número de móvil (p. ej.: 1234567890)'
                                },
                                {
                                    pattern: _setup.patternPhone,
                                    message: 'Número de móvil (p. ej.: 1234567890)'
                                }
                            ]
                        },
                        model: {
                            value: _setup.phone3,
                            callback: function callback($$v) {
                                _setup.phone3 = $$v;
                            },
                            expression: "phone3"
                        }
                    })
                ], 1)
            ]),
            _c(_setup.SelectPopup, {
                attrs: {
                    "title": 'Relación con usted',
                    "columns": _setup.columnsRelation,
                    "selection": _setup.codeRelation
                },
                on: {
                    "closePopup": function($event) {
                        _setup.showPickerRelation = false;
                    },
                    "confirm": _setup.onConfirmRelation
                },
                model: {
                    value: _setup.showPickerRelation,
                    callback: function callback($$v) {
                        _setup.showPickerRelation = $$v;
                    },
                    expression: "showPickerRelation"
                }
            }),
            _c(_setup.PrivacyDataBox, {
                on: {
                    "popup-click": function($event) {
                        _setup.agreed = true;
                    }
                },
                model: {
                    value: _setup.agreed,
                    callback: function callback($$v) {
                        _setup.agreed = $$v;
                    },
                    expression: "agreed"
                }
            }),
            _c(_setup.CreditFirstRetainPopup, {
                attrs: {
                    "step": 2
                },
                on: {
                    "close": function($event) {
                        _setup.isShowFirstRetainPopup = false;
                    },
                    "show-second": _setup.showSecondRetainPopup
                },
                model: {
                    value: _setup.isShowFirstRetainPopup,
                    callback: function callback($$v) {
                        _setup.isShowFirstRetainPopup = $$v;
                    },
                    expression: "isShowFirstRetainPopup"
                }
            }),
            _c(_setup.CreditSecondRetainPopup, {
                on: {
                    "close": function($event) {
                        _setup.isShowSecondRetainPopup = false;
                    },
                    "go-home": _setup.goAppHome
                },
                model: {
                    value: _setup.isShowSecondRetainPopup,
                    callback: function callback($$v) {
                        _setup.isShowSecondRetainPopup = $$v;
                    },
                    expression: "isShowSecondRetainPopup"
                }
            }),
            _c('van-button', {
                staticClass: "submit",
                attrs: {
                    "native-type": "submit"
                }
            }, [
                _vm._v("Siguiente")
            ])
        ], 1)
    ], 1);
};
var staticRenderFns = [
    function() {
        var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
        return _c('div', {
            staticClass: "progress"
        }, [
            _c('img', {
                attrs: {
                    "src": require("@/assets/img/credit/step2.png")
                }
            })
        ]);
    }
];
export { render, staticRenderFns };
